module.exports = __webpack_public_path__ + "media/images/flags/cf-38f43b79f3fdaedc87f400e32af4ffc1.svg";